import { QueryClient } from "@tanstack/react-query";

/**
 * Shared QueryClient instance for the application
 * Used in both the app and route loaders
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 3,
      // Disable automatic refetches on window focus to prevent unexpected UI updates
      // when the user switches tabs. Data is refreshed when explicitly requested.
      refetchOnWindowFocus: false,
    },
  },
});
